import {
  SnippetElement,
  defineElement,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/shop-newsletter/shop-newsletter.ts
var ShopNewsletter = class extends SnippetElement {
  connectedCallback() {
    return __async(this, null, function* () {
      var _a;
      if (this.successModal) {
        const url = new URL(window.location.href);
        const confirmed = url.searchParams.get("newsletter") === "confirmed" || url.searchParams.get("customer_posted") != null;
        if (confirmed) {
          (_a = this.successModal) == null ? void 0 : _a.open();
          url.searchParams.delete("newsletter");
          url.searchParams.delete("customer_posted");
          window.history.replaceState({}, "", url);
        }
      }
    });
  }
};
__decorateClass([
  query("[success-modal]")
], ShopNewsletter.prototype, "successModal", 2);
ShopNewsletter = __decorateClass([
  defineElement("shop-newsletter")
], ShopNewsletter);
export {
  ShopNewsletter
};
